"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _parse = _interopRequireDefault(require("parse"));
var _reactLinkify = _interopRequireDefault(require("react-linkify"));
var _moment = _interopRequireDefault(require("moment"));
var _reactNl2br = _interopRequireDefault(require("react-nl2br"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
_parse["default"].initialize('myAppId');
_parse["default"].serverURL = 'https://parse.thwk.co/parse';
var AppItinerary = /*#__PURE__*/function (_Component) {
  function AppItinerary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AppItinerary);
    _this = _callSuper(this, AppItinerary, [props]);
    // Inlined styles to avoid need for custom css loader for a single component
    (0, _defineProperty2["default"])(_this, "styles", function () {
      var styleObject = {
        ScheduleDayTabs: {
          display: 'flex',
          paddingTop: '15px',
          whiteSpace: 'pre-line',
          cursor: 'pointer'
        },
        ScheduleDayTab: {
          flex: 1,
          padding: '8px',
          textAlign: 'center',
          borderBottom: '2px solid #c5c5c5',
          color: '#a7a7a7'
        },
        ScheduleDayEvent: {
          width: '600px',
          padding: '10px',
          borderBottom: '1px solid #ebebeb'
        },
        ScheduleDayEventTitle: {
          fontWeight: 500,
          fontSize: '18px'
        },
        ScheduleDayEventDate: {
          marginTop: '5px',
          color: '#888',
          fontSize: '14px'
        },
        ScheduleDayEventDescription: {
          marginTop: '6px',
          lineHeight: '22px',
          fontSize: '16px'
        },
        activeTab: {
          borderBottom: '2px solid #239BD7',
          color: '#239BD7'
        }
      };
      if (_this.state.dayTabFocus) {
        styleObject = _objectSpread(_objectSpread({}, styleObject), {}, {
          ScheduleDayTab: _objectSpread(_objectSpread({}, styleObject.ScheduleDayTab), {}, {
            outline: 'none'
          })
        });
      }
      return styleObject;
    });
    _this.state = {
      indexDay: 0,
      dayTabFocus: false
    };
    return _this;
  }
  (0, _inherits2["default"])(AppItinerary, _Component);
  return (0, _createClass2["default"])(AppItinerary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var eventId, event;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              eventId = this.props.eventId;
              if (eventId) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              event = new _parse["default"].Object('Event');
              event.id = eventId;
              this.event = event;
              _context.next = 8;
              return this.loadSchedule();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "loadSchedule",
    value: function () {
      var _loadSchedule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var eventId, days;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              eventId = this.props.eventId;
              _context2.next = 3;
              return _parse["default"].Cloud.run('getEventInfo', {
                eventId: eventId
              });
            case 3:
              days = _context2.sent;
              this.setState(days);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadSchedule() {
        return _loadSchedule.apply(this, arguments);
      }
      return loadSchedule;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        indexDay = _this$state.indexDay,
        days = _this$state.days;
      var _this$props = this.props,
        showSchedule = _this$props.showSchedule,
        editUrl = _this$props.editUrl,
        renderEmptyView = _this$props.renderEmptyView,
        truncateDescriptions = _this$props.truncateDescriptions;
      var schedule;
      if (renderEmptyView && !days) {
        schedule = renderEmptyView();
      } else if (!days) {
        schedule = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingTop: 15
          }
        }, "Loading");
      } else {
        var day = days[indexDay];
        var items = day.items,
          title = day.title,
          description = day.description;
        schedule = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h3", {
          style: {
            marginTop: 14
          }
        }, "Day ", indexDay + 1, " - ", title), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactLinkify["default"], null, (0, _reactNl2br["default"])(description))), showSchedule && items.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.id,
            style: _this2.styles().ScheduleDayEvent
          }, editUrl ? /*#__PURE__*/_react["default"].createElement("a", {
            style: _this2.styles().ScheduleDayEventTitle,
            href: "".concat(editUrl, "/").concat(item.id)
          }, item.title) : item.title, /*#__PURE__*/_react["default"].createElement("div", {
            style: _this2.styles().ScheduleDayEventDate
          }, _moment["default"].utc(item.date).format('h:mma'), " at ", item.location), /*#__PURE__*/_react["default"].createElement(_reactLinkify["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
            style: _this2.styles().ScheduleDayEventDescription
          }, truncateDescriptions ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _reactNl2br["default"])(item.description && item.description.substr(0, 100)), "...") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _reactNl2br["default"])(item.description)))));
        }));
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: this.styles().ScheduleDayTabs
      }, this.state.days && this.state.days.map(function (item, key) {
        var style = _this2.styles().ScheduleDayTab;
        if (_this2.state.indexDay === key) {
          var activeTabStyle = _this2.styles().activeTab;
          style = _objectSpread(_objectSpread({}, style), activeTabStyle);
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: key,
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this2.setState({
              indexDay: key
            });
          },
          onFocus: function onFocus() {
            return _this2.setState({
              dayTabFocus: true
            });
          },
          onBlur: function onBlur() {
            return _this2.setState({
              dayTabFocus: false
            });
          },
          style: style
        }, _moment["default"].utc(item.date).format('ddd[\n]DD'));
      })), schedule);
    }
  }]);
}(_react.Component);
AppItinerary.propTypes = {
  eventId: _propTypes["default"].string,
  showSchedule: _propTypes["default"].bool,
  truncateDescriptions: _propTypes["default"].bool,
  editUrl: _propTypes["default"].string,
  renderEmptyView: _propTypes["default"].func
};
AppItinerary.defaultProps = {
  showSchedule: true,
  truncateDescriptions: true,
  editUrl: null,
  renderEmptyView: null
};
var _default = exports["default"] = AppItinerary;